// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { LazySearchPageNoPrefetch } from "@faire/retailer/views/search-v2/__internal__/LazySearchPage/LazySearchPage";

import { preload } from "./__internal__/preload";

const preloadLazySearchPage = () => {
  preload(LazySearchPageNoPrefetch);
};

export default preloadLazySearchPage;
